import { useEffect, useState, useCallback } from 'react';
import { Modal } from 'antd';
import { IconWifi, IconCloseCircle } from '@/utils/icons';
import { CHECK_INTERVAL_MS } from '@/utils/constants';

function InternetConnectivityModal() {
  const [isOffline, setIsOffline] = useState(false);

  const runCheck = useCallback(() => {
    setIsOffline(!window.navigator.onLine);
  }, []);

  useEffect(() => {
    runCheck();
    const intervalId = setInterval(runCheck, CHECK_INTERVAL_MS);

    window.addEventListener('online', runCheck);
    window.addEventListener('offline', runCheck);

    return () => {
      clearInterval(intervalId);
      window.removeEventListener('online', runCheck);
      window.removeEventListener('offline', runCheck);
    };
  }, [runCheck]);

  return (
    <Modal
      open={isOffline}
      closable={false}
      maskClosable={false}
      footer={null}
      keyboard={false}
      width={400}
      centered
      zIndex={10000}
    >
      <div className="text-center py-2">
        <IconCloseCircle
          className="text-[56px] text-[#ff4d4f] mb-4"
        />
        <h3 className="mb-2">No Internet Connection</h3>
        <p className="text-[#666] m-0">
          Please check your connection. We'll retry automatically every few
          seconds.
        </p>
        <div className="mt-4">
          <IconWifi spin className="text-2xl text-[#1890ff]" />
        </div>
      </div>
    </Modal>
  );
}

export default InternetConnectivityModal;
